import { parseISO, format } from "date-fns";

export function formatDate (date) {
    const parsedDate = parseISO(date);
    if (!isNaN(parsedDate.getTime())) {
      const formattedDate = format(parsedDate, 'yyyy-MM-dd');
      const formattedDateInOriginalFormat = parseISO(formattedDate);
      return formattedDateInOriginalFormat;
    }
  };